import { AddInsightToCollectionsButton, CreateInsightDataFn, Proposition } from '@ecosystem/newron-client-collections';
import { FC } from 'react';
import classnames from 'classnames';
import * as styles from './OpportunityReviewCollectionButton.module.scss';
import { OpportunityReviewBubbleChartInsight } from '../collections/opportunity-review-bubble-chart/Model';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { CollectionInsightType } from '../collections/Model';
import { getCollectionsAmplitudeTrackingTags } from '@utils/collectionUtils/CollectionUtils';
import { CreateViewStateFn } from '@ecosystem/newron-client-lib';

export interface OpportunityReviewCollectionButtonProps {
  isTableView: boolean;
  isDisabled: boolean;
  createInsightDataFn: CreateInsightDataFn<OpportunityReviewBubbleChartInsight>;
  createViewStateFn?: CreateViewStateFn<any>;
}

const OpportunityReviewCollectionButton: FC<OpportunityReviewCollectionButtonProps> = ({
  isTableView,
  isDisabled,
  createInsightDataFn,
  createViewStateFn,
}) => {
  const pagesConfig = usePageConfig();

  if (isTableView) {
    return null;
  }

  return (
    <div
      className={classnames([
        {
          [styles.OpportunityReviewCollectionButton]: !isDisabled,
          [styles.OpportunityReviewCollectionButtonDisabled]: isDisabled,
        },
      ])}
    >
      <AddInsightToCollectionsButton<OpportunityReviewBubbleChartInsight>
        type={CollectionInsightType.OpportunityReviewBubbleChart}
        proposition={Proposition.Retail}
        createInsightDataFn={createInsightDataFn}
        selectDataType={true}
        defaultDataType={'live'}
        getTrackingTags={getCollectionsAmplitudeTrackingTags(pagesConfig)}
        createViewStateFn={createViewStateFn}
      />
    </div>
  );
};

export default OpportunityReviewCollectionButton;
